import React from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel, Paper, List, ListItem, ListItemText, ListSubheader, Checkbox, FormControlLabel, Link } from '@mui/material';

const storyTypeMap = {
    "hero": "Hero's Journey",
    "heroine": "Heroine's Journey"
};

const premiseMap = {
    "premise1": "A human created an artificial human. Then this human (the creator/lover) fell in love with the artificial human.",
    "premise2": "Years after a plague kills most of humanity and transforms the rest into monsters, the sole survivor in New York City struggles valiantly to find a cure.",
    "premise3": "The lights go out, then when they turn back on, someone has been murdered."
};

const Sidebar = ({
    selectedModel,
    selectedPremise,
    selectedType,
    selectedNumber,
    modelNames,
    premiseNames,
    storyTypes,
    storyTitles,
    showDifferences,
    onToggleDifferences,
    onModelChange,
    onPremiseChange,
    onTypeChange,
    onStorySelect,
}) => {
    return (
        <Box 
            sx={{ 
                width: '300px', 
                minWidth: '300px', 
                height: '100%', 
                backgroundColor: '#f4f4f4', 
                padding: 2, 
                boxSizing: 'border-box',
                overflowY: 'auto'
            }}
        >
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <InputLabel 
                    sx={{ 
                        backgroundColor: '#f4f4f4', 
                        padding: '0 4px', 
                        '&.Mui-focused': {
                            backgroundColor: '#f4f4f4',
                        }
                    }}
                >
                    LLM
                </InputLabel>
                <Select value={selectedModel} onChange={onModelChange}>
                    {modelNames.map((model) => (
                        <MenuItem key={model} value={model}>{model}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <InputLabel 
                    sx={{ 
                        backgroundColor: '#f4f4f4', 
                        padding: '0 4px', 
                        '&.Mui-focused': {
                            backgroundColor: '#f4f4f4',
                        }
                    }}
                >
                    Premise
                </InputLabel>
                <Select value={selectedPremise} onChange={onPremiseChange}>
                    {premiseNames.map((premise) => (
                        <MenuItem key={premise} value={premise}>{premiseMap[premise] || premise}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <InputLabel 
                    sx={{ 
                        backgroundColor: '#f4f4f4', 
                        padding: '0 4px', 
                        '&.Mui-focused': {
                            backgroundColor: '#f4f4f4',
                        }
                    }}
                >
                    Narrative Structure
                </InputLabel>
                <Select value={selectedType} onChange={onTypeChange}>
                    {storyTypes.map((type) => (
                        <MenuItem key={type} value={type}>{storyTypeMap[type] || type}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            {storyTitles.length > 0 && (
                <>
                    <Paper sx={{ maxHeight: '500px', overflow: 'auto', marginTop: 1 }}>
                        <List dense subheader={<ListSubheader>Narratives</ListSubheader>}>
                            {storyTitles.map(({ index, title }) => (
                                <ListItem 
                                    key={index} 
                                    button 
                                    onClick={() => onStorySelect(index)} 
                                    selected={selectedNumber === index}
                                    sx={{
                                        backgroundColor: selectedNumber === index ? '#e0e0e0' : 'inherit',
                                        '&.Mui-selected': {
                                            backgroundColor: '#b0c4de',
                                            '&:hover': {
                                                backgroundColor: '#a0b8d8',
                                            },
                                        },
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                        },
                                    }}
                                >
                                    <ListItemText primary={`${index + 1}. ${title}`} />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                    <FormControlLabel
                        control={<Checkbox checked={showDifferences} onChange={onToggleDifferences} />}
                        label="Highlight Differences"
                        sx={{ marginBottom: 2, marginTop: 1 }}
                    />
                </>
            )}
            <Box sx={{ marginTop: 2 }}>
                <Link 
                    href="/hero-bias-dataset/hero-heroine-dataset-v1.zip" 
                    download 
                    target="_blank" 
                    rel="noopener noreferrer"
                    sx={{ color: '#1976d2', textAlign: 'center', display: 'block' }}
                >
                    Download Full Dataset
                </Link>
            </Box>
            <Box sx={{ marginTop: 2 }}>
                <Link 
                    href="/hero-bias-dataset/hero-heroine-source-v1.zip" 
                    download 
                    target="_blank" 
                    rel="noopener noreferrer"
                    sx={{ color: '#1976d2', textAlign: 'center', display: 'block' }}
                >
                    Download Source Code
                </Link>
            </Box>
        </Box>
    );
};

export default Sidebar;
